@switch (type()) {
  @case ('infinitform') {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xml:space="preserve"
      style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
      viewBox="-2 -3 180 120">
      <path
        class="path"
        d="M8132.21 3668.58c-1.47-2.43-3.99-3.9-6.71-3.9l-160.02-.01c-43.67 0-79.06-37.69-79.06-84.18v-53.59c0-46.5 35.4-84.19 79.06-84.19h37.61c8.29 0 16.01 4.49 20.5 11.91l27.52 45.55c1.48 2.44 4.01 3.91 6.74 3.91h158.05c43.67 0 79.07 37.7 79.07 84.19v53.6c0 22.33-8.33 43.74-23.16 59.53s-34.94 24.66-55.91 24.66h-35.65c-8.29 0-16.02-4.49-20.5-11.91l-27.54-45.57Zm12.01-7.81c1.48 2.44 4.01 3.91 6.73 3.91h67.97c4.89 0 9.57-2.06 13.03-5.74 3.45-3.68 5.39-8.67 5.39-13.87v-60c0-10.83-8.24-19.62-18.42-19.62h-130.2c-9.28 0-17.91-5.01-22.93-13.32l-26.69-44.15c-1.46-2.43-3.99-3.9-6.71-3.9h-69.93c-4.88 0-9.57 2.07-13.02 5.75-3.46 3.68-5.4 8.66-5.4 13.87v60c0 5.2 1.94 10.19 5.4 13.87 3.45 3.67 8.14 5.74 13.02 5.74h132.16c9.27 0 17.91 5.02 22.93 13.32l26.67 44.14Z"
        transform="matrix(.4314 0 0 .40516 -3402.2 -1394.84)"></path>
    </svg>
  }
  @case ('simple') {
    <div class="simple" [class.sm]="size() === 'sm'" [class.md]="size() === 'md'" [class.lg]="size() === 'lg'"></div>
  }
}
